import { ReactNode } from 'react';

import { OfferModel } from '../../../../../offer/model/OfferModel';
import { RfqOfferCardContext } from '../../../components/RfqOfferCard/components/RfqOfferCardContext';

interface RfqOfferCardContextProviderProps {
    offer: OfferModel;
    children: ReactNode;
}

export const RfqOfferCardContextProvider = ({ offer, children }: RfqOfferCardContextProviderProps) => {
    return <RfqOfferCardContext.Provider value={{ offer }}>{children}</RfqOfferCardContext.Provider>;
};
